<template>
<div>
	<div class="login-form-part">
		<p class="platform-name">卖家登录</p>
		<el-form :model="loginForm" :rules="rules" ref="loginForm" class="login-form">
			<el-form-item prop="username">
				<div class="login-item">
					<i class="login-icon" :class="userFocus ? 'userFocus' : 'userBlur'"/>
					<el-input
						v-model="loginForm.username"
						placeholder="请输入账号"
						class="login-input"
						@focus="userHandle(true)"
						@blur="userHandle(false)"
						:clearable="true"
						@keyup.enter.native="verifyPost('loginForm')"
					></el-input>
				</div>
			</el-form-item>
			<el-form-item prop="password">
				<div class="login-item">
					<i class="login-icon" :class="pwdFocus ? 'pwdFocus' : 'pwdBlur'"/>
					<el-input
						v-model="loginForm.password"
						placeholder="请输入密码"
						class="login-input"
						@focus="pwdHandle(true)"
						@blur="pwdHandle(false)"
						:type="pwdShow ? 'text' : 'password'"
						:clearable="true"
						@keyup.enter.native="verifyPost('loginForm')"
					></el-input>
					<i class="login-icon" :class="pwdShow ? 'pwdShow' : 'pwdHidden'" @click="pwdShowHandle"></i>
				</div>
			</el-form-item>
			<el-form-item prop="verify">
				<div class="verify-item">
					<div class="verify-num-box">
						{{verifyNum1}} + {{verifyNum2}}
					</div>
					<span>=</span>
					<el-input
						v-model="loginForm.verify"
						class="verify-input"
						type="text"
						@keyup.enter.native="verifyPost('loginForm')"
					></el-input>
				</div>
			</el-form-item>
			<el-button type="primary" class="login-button" @click="verifyPost('loginForm')">登录</el-button>
			<div class="agreement-box">
				<el-checkbox v-model="checked"></el-checkbox>
				<span @click="agreeClick" style="cursor:pointer">我已阅读并同意</span><span @click="goAgreement" class="agreement">《极速订平台服务协议》</span>、<span @click="goTCSLAgreement" class="agreement">《天财商龙用户服务协议》</span>、<span @click="goPrivate" class="agreement">《天财商龙隐私政策》</span>
			</div>
			<div class="link-box">
				<div class="left">
					<!-- <el-checkbox v-model="rememberMe"><span style="font-size: 12px;">7天内自动登录</span></el-checkbox> -->
				</div>
				<div class="right" style="display: flex;">
					<!-- <router-link to="/register" class="register">立即注册</router-link>
					<div style="margin: 2px 3px;
						width: 1px;
						height: 15px;
						background: #333;">
					</div> -->
					<div class="forgetpwd" @click="FindPwdHandle">忘记密码？</div>
				</div>
			</div>
		</el-form>
		<!-- <el-dialog
			title="公告"
			:visible.sync="showTip"
			top='30vh'
			:close-on-click-modal='false'
			width="500px">
			<div style="text-align:left">
				<div>各位商家：</div>
				<div style="margin-left:30px">您好！</div>
				<div>
					<span style="margin-left:30px">
						为了给各位商家提供更好的平台服务，暂定于
						<span style="color:red">2022.2.21</span>
						对开通管理后台系统进行迭代升级，届时在2021.2.21以前开通的店铺将失效，店铺状态将变更为“未营业”，该状态下，买家小程序将无法正常进行采购业务及卖家后台部分功能将无法正常使用，请各位商家核实店铺的开通日期，若存在已过期或即将过期的店铺，请联系天财商龙团队进行续费申请
					</span>
				</div>
			</div>
		</el-dialog> -->
	</div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import { inputAutoFocus } from '@/js/lib/form'
export default {
	name: 'loginForm',
	data () {
		return {
			loginForm: {
				username: '',
				password: '',
				verify: ''
			},
			rules: {
				username: [
					{ required: true, message: '请输入账号', trigger: 'blur' }
				],
				password: [
					{ required: true, message: '请输入密码', trigger: 'blur' }
				],
				verify: [
					{ required: true, message: '请输入验证码', trigger: 'blur' }
				]
			},
			userFocus: false,
			pwdFocus: false,
			pwdShow: false,
			verifyNum1: 0,
			verifyNum2: 0,
			rememberMe: false,
			showTip: false,
			checked: false
		}
	},
	created () {
		if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
			this.loginForm.username = this.$route.query.username
			this.loginForm.password = window.atob(this.$route.query.password)
			this.checked = this.$route.query.checked === 'true'
			this.rememberMe = this.$route.query.rememberMe === 'true'
		}
		this.verifyNum1 = Math.floor(Math.random() * 10)
		this.verifyNum2 = Math.floor(Math.random() * 10)
	},
	computed: {
		...mapState({
			platFormName: state => state.platFormStore.platFormName
		})
	},
	methods: {
		goAgreement () {
			this.$router.push({ path: '/agreement', query: { username: this.loginForm.username, password: window.btoa(this.loginForm.password), checked: this.checked, rememberMe: this.rememberMe } })
		},
		goTCSLAgreement () {
			window.open('https://yun.tcsl.com.cn/reportforms/#/UserAgreement', '_blank')
		},
		goPrivate () {
			window.open('https://yun.tcsl.com.cn/reportforms/#/SecretAgreement', '_blank')
		},
		userHandle (bool) {
			this.userFocus = bool
		},
		pwdHandle (bool) {
			this.pwdFocus = bool
		},
		pwdShowHandle () {
			this.pwdShow = !this.pwdShow
		},
		onKeyupInput () {
			inputAutoFocus.apply(this, [event, 'loginForm']).then(() => {
				this.verifyPost('loginForm')
			})
		},
		agreeClick () {
			this.checked = !this.checked
		},
		verifyPost (formName) {
			return new Promise((resolve, reject) => {
				var formData = new FormData()
				formData.append('verifyNum1', +this.verifyNum1)
				formData.append('verifyNum2', +this.verifyNum2)
				formData.append('verify', +this.loginForm.verify)
				this.$store.dispatch('requestFilePost', {
					url: `${this.$fxBaseApi.urlNVA}/validate`,
					data: formData
				}).then(res => {
					this.login(formName)
				}, error => {
					console.log(error)
				})
			})
		},
		login (formName) {
			this.$refs[formName].validate(valid => {
				valid && this.loginPost()
			})
		},
		getSettlement () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/isSettlement`
			}).then(res => {
				window.sessionStorage.setItem('isSettlement', res.data.isSettlement)
				const { host, pathname } = window.location
				let session = window.sessionStorage.getItem('shiroSession')
				window.location.href = `https://${host}${pathname}#/main/home?session=${session}`
			})
		},
		loginPost () {
			if (!this.checked) {
				this.$message.error('请阅读并勾选协议')
				return false
			}
			var param = {
				username: this.loginForm.username,
				password: this.loginForm.password,
				rememberMe: true
			}
			this.$fxLogger.clearSyscodeInfo()
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVA}/login`,
				data: param
			}).then(res => {
				if (res.code === 3100) {
					location.reload()
					return false
				}
				if (res.result === false) {
					this.$message.error(res.msg)
					return false
				}
				window.sessionStorage.setItem('shiroSession', res.shiroSession)
				window.sessionStorage.setItem('entid', res.entid)
				document.cookie = 'usernameycg:' + this.loginForm.username
				window.sessionStorage.removeItem('organid')
				this.getSettlement()
			})
		},
		FindPwdHandle () {
			window.sessionStorage.removeItem('shiroSession')
			this.$router.push({
				path: 'findPassWord',
				query: { username: this.loginForm.username }
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.login-form-part {
	display flex
	flex-direction column
	align-items center
	padding-top 30px
	.platform-name {
		font-weight 700
		font-size 20px
		padding: 30px 0
	}
	.login-form {
		width: 350px
		.login-item {
			display flex
			flex-direction row
			align-items center
			border-bottom: 1px solid #7e8388
			line-height: 42px;
			.login-input {
				width 290px
			}
			/deep/ .el-input__inner {
				&::placeholder {
					font: 100% tahoma, "\5B8B\4F53", arial;
					color: #9fa2a5
				}
				&::-webkit-input-placeholder {
					font: 100% tahoma, "\5B8B\4F53", arial;
					color: #9fa2a5
				}
			}
			.login-icon {
				display inline-block
				width 25px
				height 25px
			}
			.userFocus {
				background-image: url('~images/icon/user-active.png')
			}
			.userBlur {
				background-image: url('~images/icon/user.png')
			}
			.pwdFocus {
				background-image: url('~images/icon/pwd-active.png')
			}
			.pwdBlur {
				background-image: url('~images/icon/pwd.png')
			}
			.pwdShow {
				background-image: url('~images/icon/pwd-show.png')
			}
			.pwdHidden {
				background-image: url('~images/icon/pwd-hidden.png')
			}
		}
		.verify-item {
			display flex
			font-size 20px
			.verify-num-box {
				flex 5
				border: 1px solid #7e8388
				border-radius 4px
			}
			span {
				flex 1
			}
			.verify-input {
				flex 2
				font-size 20px
				border: 1px solid #7e8388
				border-radius 4px
				/deep/input {
					text-align center
				}
			}
		}
		.login-button {
			width: 350px
			margin: 40px 0 20px
		}
		.link-box {
			display: flex;
			justify-content space-between
			.register ,.forgetpwd{
				text-decoration: underline
				cursor: pointer
			}
			.forgetpwd:hover {
				color: var(--fx-primary-color)
			}
		}
	}
	.agreement-box {
		text-align: left
		margin-top: 10px
		margin-bottom: 15px
		font-size: 14px
		.el-checkbox {
			margin-right: 10px
		}
		.agreement {
			color: var(--fx-primary-color)
			cursor: pointer
		}
	}
	/deep/.el-input__inner {
		border: none
		background none
	}
	.el-form-item{
		margin-bottom 22px
	}
}
</style>
<style lang="stylus">
.login-form-part{
	.el-dialog__body {
		padding:0 20px 20px 20px
	}
	.el-dialog__title {
		padding-left: 0 !important;
		border-left: none !important;
	}
}
</style>
